import { FilterOptionType } from 'src/components/RealityCheckForm/CustomDropdown';
import { DEPOSIT_RESTRICTION_OPTIONS_ARRAY } from 'src/components/CustomersBar/CustomerTab/ResponsibleGamblingTab/DepositRestrictionTab/DepositRestrictionTab.state';

export const GAMSTOP_PP_COMPLIANCE_RESTRICTION_OPTIONS_ARRAY: Array<FilterOptionType<string>> = [
    { value: '7', label: '7 days' },
    { value: '14', label: '14 days' },
    { value: '30', label: '30 days' },
];

export const GAMSTOP_PP_DEPOSIT_RESTRICTION_OPTIONS_ARRAY = DEPOSIT_RESTRICTION_OPTIONS_ARRAY;

export const DEFAULT_GAMSTOP_PP_COMPLIANCE_RESTRICTION_PERIOD =
    GAMSTOP_PP_COMPLIANCE_RESTRICTION_OPTIONS_ARRAY[0]?.value ?? '7';

export const DEFAULT_GAMSTOP_PP_DEPOSIT_RESTRICTION_PERIOD =
    GAMSTOP_PP_DEPOSIT_RESTRICTION_OPTIONS_ARRAY[0]?.value ?? 1;
